var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control",domProps:{"value":_vm.value},on:{"change":_vm.onChange}},[_c('option',{attrs:{"value":""}},[_vm._v("--SELECT--")]),_vm._l((_vm.countries),function(country){return _c('option',{key:country.label,domProps:{"value":country.label}},[_vm._v(" "+_vm._s(country.label)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }